import React from "react";
import { reactPlugin } from "./AppInsights";
import { AppInsightsErrorBoundary as AzureAppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";
import ErrorMsg from "../ErrorMsg";
export const AppInsightsErrorBoundary = ({ children }) => {
  return (
    <AzureAppInsightsErrorBoundary
      onError={() => {
        return <ErrorMsg showRefresh={true} />;
      }}
      appInsights={reactPlugin}
    >
      {children}
    </AzureAppInsightsErrorBoundary>
  );
};
